import { httpRequest } from "../../../utils/HttpRequest";
import { IMaintenanceList, IMaintenanceSearch } from "./MaintenanceType"
class Maintenanceservice {
    async mainAmount(params: IMaintenanceSearch) {
        const apiUrl = `/vrm-sa/statistics/mainAmount`;
        return await httpRequest.post<IMaintenanceList>(apiUrl, params);
    }
    //工单批量导出
    async export(params: IMaintenanceSearch) {
        const apiUrl = "/vrm-sa/maintenance/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
}
export const maintenanceservice = new Maintenanceservice();
